import React from "react";
import { ConcessionaireAddressRegisterTemplate } from "../../Templates/ConcessionaireAddressRegisterTemplate";

export const ConcessionaireAddressRegister = () => {
  return <ConcessionaireAddressRegisterTemplate />;
};
